module.exports = __webpack_public_path__ + "img/hr-transport-belt.323956eb.png";